import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-end mb-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-filter" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "card d-flex"
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "card-header" }
const _hoisted_7 = { class: "card-title" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-list-ul" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_10 = { class: "text-gray-500" }
const _hoisted_11 = { class: "row mt-3 p-5" }
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "text-gray-700 mb-2" }
const _hoisted_15 = { class: "text-gray-500" }
const _hoisted_16 = {
  selected: "",
  value: ""
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "easy" }, "Easy", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "medium" }, "Medium", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: "hard" }, "Hard", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", { value: "insane" }, "Insane", -1)
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "text-gray-700 mb-2" }
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "text-gray-700 mb-2" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Status ")
const _hoisted_28 = { class: "text-gray-500" }
const _hoisted_29 = {
  selected: "",
  value: ""
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", { value: "completed" }, "Owned", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "started" }, "Started", -1)
const _hoisted_32 = { value: "unstarted" }
const _hoisted_33 = { class: "col-md-4 mt-2" }
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "text-gray-700 mb-2" }, "Freemium", -1)
const _hoisted_36 = { value: null }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", { value: true }, "Free", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("option", { value: false }, "Premium", -1)
const _hoisted_39 = { class: "col-md-10 mt-2" }
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = { class: "text-gray-700 mb-2" }
const _hoisted_42 = { class: "col-md-2 d-flex justify-content-end align-items-end" }
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_45 = {
  key: 1,
  class: "indicator-label"
}
const _hoisted_46 = {
  key: 1,
  class: "mt-10 text-center"
}
const _hoisted_47 = { class: "row g-6 g-xl-9" }
const _hoisted_48 = {
  key: 0,
  class: "row mt-10"
}
const _hoisted_49 = { class: "col-md-12" }
const _hoisted_50 = {
  class: "",
  role: "alert"
}
const _hoisted_51 = { class: "alert-heading" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_54 = { class: "text-gray-500" }
const _hoisted_55 = { class: "text-gray-500" }
const _hoisted_56 = ["href"]
const _hoisted_57 = { class: "card-header border-0 pt-9" }
const _hoisted_58 = { class: "card-toolbar" }
const _hoisted_59 = {
  key: 0,
  class: "badge badge-light-primary fw-bolder me-auto px-4 py-3"
}
const _hoisted_60 = {
  key: 1,
  class: "badge badge-light-success fw-bolder me-auto px-4 py-3"
}
const _hoisted_61 = {
  key: 2,
  class: "badge badge-light-warning fw-bolder me-auto px-4 py-3"
}
const _hoisted_62 = { class: "card-body pt-4 p-9" }
const _hoisted_63 = { class: "fs-3 fw-bolder text-dark d-flex justify-content-center" }
const _hoisted_64 = { class: "dificulty mb-5 mt-3 d-flex justify-content-center" }
const _hoisted_65 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_66 = {
  key: 1,
  class: "badge badge-light-info"
}
const _hoisted_67 = {
  key: 2,
  class: "badge badge-light-warning"
}
const _hoisted_68 = {
  key: 3,
  class: "badge badge-light-danger"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 fw-bold fs-5 mt-1 mb-7" }, null, -1)
const _hoisted_70 = { class: "dificulty mb-5 mt-3 d-flex justify-content-center gap-2" }
const _hoisted_71 = { class: "d-flex flex-wrap mb-5 justify-content-center" }
const _hoisted_72 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-7 mb-3" }
const _hoisted_73 = { class: "fs-6 text-gray-800 fw-bolder" }
const _hoisted_74 = { class: "fw-bold text-gray-500" }
const _hoisted_75 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 mb-3" }
const _hoisted_76 = { class: "fs-6 text-gray-800 fw-bolder" }
const _hoisted_77 = { class: "fw-bold text-gray-500" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-gem text-warning" }, null, -1)
const _hoisted_79 = {
  class: "h-4px w-100 bg-light mb-5",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": "This project 50% completed"
}
const _hoisted_80 = ["aria-valuenow"]
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "col-md-6" }
const _hoisted_83 = { class: "text-gray-600 fs-6" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-shield" }, null, -1)
const _hoisted_85 = { class: "symbol-group symbol-hover justify-content-center" }
const _hoisted_86 = {
  class: "symbol symbol-35px symbol-circle",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": "Emma Smith"
}
const _hoisted_87 = ["src", "title"]
const _hoisted_88 = { class: "col-md-6" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("small", { class: "text-gray-600 fs-6" }, [
  /*#__PURE__*/_createTextVNode("First Blood "),
  /*#__PURE__*/_createElementVNode("i", { class: "las la-tint text-danger" })
], -1)
const _hoisted_90 = { class: "symbol-group symbol-hover justify-content-center" }
const _hoisted_91 = {
  class: "symbol symbol-35px symbol-circle",
  "data-bs-toggle": "tooltip",
  title: "",
  "data-bs-original-title": "Emma Smith"
}
const _hoisted_92 = ["src", "title"]
const _hoisted_93 = { class: "pagination pagination-outline mt-10" }
const _hoisted_94 = ["onClick"]
const _hoisted_95 = ["innerHTML"]
const _hoisted_96 = {
  key: 2,
  class: "justify-content-center d-flex flex-center"
}
const _hoisted_97 = {
  class: "spinner-border spinner-border-sm",
  role: "status"
}
const _hoisted_98 = { class: "sr-only" }

import router from "@/router";
import { computed, onMounted, ref } from "vue";
import { useI18n } from 'vue-i18n'
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import moment from "moment";
import { IChallengeMetadata } from "@/types/ChallengeType";
import apiService from "@/core/services/ApiService";
import Multiselect from "@vueform/multiselect";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const { t } = useI18n()
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));

const show_filter = ref(false)

const filter = ref({
  search: '',
  dificulty: '',
  status: '',
  categories: [],
  is_freemium: null as boolean | null
})

const loading = ref(true)

const doSearch = async () => {

  if (filter.value.search || filter.value.dificulty || filter.value.status || filter.value.categories.length > 0 || filter.value.is_freemium !== null) {
    window.history.pushState({}, "", "/training/challenges?page=1&search=" + filter.value.search + "&dificulty=" + filter.value.dificulty + "&status=" + filter.value.status + "&categories=" + filter.value.categories.join(",") + "&is_freemium=" + filter.value.is_freemium);
  } else {
    window.history.pushState({}, "", "/training/challenges");
  }

  if (loading.value) {
    return;
  }

  loading.value = true;

  await store.dispatch(Actions.GET_FILTERED_CHALLENGES, {
    type: "training",
    dificulty: filter.value.dificulty,
    status: filter.value.status,
    search: filter.value.search,
    categories: filter.value.categories.join(","),
    is_freemium: filter.value.is_freemium
  });
  challenges.value = store.getters.getChallenges;
  currentMetadata.value = store.getters.getChallengesMetadata;
  loading.value = false;
}

const query: any = router.currentRoute.value.query;
const page: number = query.page ? parseInt(query?.page) : 1;
const search: string = query.search ? query.search : "";
const dificulty: string = query.dificulty ? query.dificulty : "";
const status: string = query.status ? query.status : "";

let is_freemium: boolean | null = null;
if (query.is_freemium === "true") {
  is_freemium = true;
} else if (query.is_freemium === "false") {
  is_freemium = false;
}

const challenges = ref([]) as Challenge[];
const currentMetadata = ref({ links: [] }) as IChallengeMetadata;

const categories = ref([]) as any[];

onMounted(async () => {
  setCurrentPageTitle("Challenges List");

  if (page !== 1 || search !== "" || dificulty !== "" || status !== "" || query.categories != null || is_freemium !== null) {
    filter.value.dificulty = dificulty;
    filter.value.status = status;
    filter.value.search = search;
    filter.value.categories = query.categories ? query.categories.split(",") : [];
    filter.value.is_freemium = is_freemium;
    show_filter.value = true;

    await store.dispatch(Actions.GET_FILTERED_CHALLENGES, { type: "training", search: search, page: page, dificulty: dificulty, status: status, categories: query.categories || "", is_freemium: is_freemium });
  } else {
    await store.dispatch(Actions.GET_FILTERED_CHALLENGES, { type: "training" });
  }

  const categoriesResponse = await apiService.vueInstance.axios.get("/account/tags/categories")
  categories.value = categoriesResponse.data.data;

  challenges.value = store.getters.getChallenges;
  currentMetadata.value = store.getters.getChallengesMetadata;

  loading.value = false
});

const goTo = async (url) => {
  if (url) {
    const page = url.split("page=")[1];
    const queryParams = router.currentRoute.value.query;
    const hasFilters = queryParams.search || queryParams.dificulty || queryParams.status || queryParams.is_freemium || (queryParams.categories && queryParams.categories.length > 0);

    if (hasFilters) {
      const searchParam = queryParams.search || filter.value.search || "";
      const dificultyParam = queryParams.dificulty || filter.value.dificulty || "";
      const statusParam = queryParams.status || filter.value.status || "";
      const categoriesParam = queryParams.categories || filter.value.categories.join(",") || "";

      let isFreemiumParam = "";
      if (queryParams.is_freemium !== undefined && queryParams.is_freemium !== null) {
        isFreemiumParam = String(queryParams.is_freemium);
      } else if (filter.value.is_freemium !== null) {
        isFreemiumParam = String(filter.value.is_freemium);
      }

      window.history.pushState({}, "", "/training/challenges?page=" + page +
        (searchParam ? "&search=" + searchParam : "") +
        (dificultyParam ? "&dificulty=" + dificultyParam : "") +
        (statusParam ? "&status=" + statusParam : "") +
        (categoriesParam ? "&categories=" + categoriesParam : "") +
        (isFreemiumParam !== "" ? "&is_freemium=" + isFreemiumParam : ""));
    } else {
      window.history.pushState({}, "", "/training/challenges?page=" + page);
    }

    loading.value = true;
    await store.dispatch(Actions.GET_FILTERED_CHALLENGES, {
      type: "training",
      dificulty: filter.value.dificulty,
      status: filter.value.status,
      search: filter.value.search,
      categories: filter.value.categories.join(","),
      page: page,
      is_freemium: filter.value.is_freemium
    });
    challenges.value = store.getters.getChallenges;
    currentMetadata.value = store.getters.getChallengesMetadata;
    loading.value = false;
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "btn btn-secondary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (show_filter.value = !show_filter.value))
      }, [
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.filter`)) + " " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.challenges`)), 1)
      ])
    ]),
    (show_filter.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h4", _hoisted_7, [
                  _hoisted_8,
                  _hoisted_9,
                  _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.challenge.machine_filter_desc`)), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, [
                  _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.level`)) + " ", 1),
                  _createElementVNode("b", _hoisted_15, " - " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.challenge.machine`)) + " " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.difficulty`)), 1)
                ]),
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (doSearch())),
                  class: "form-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filter.value.dificulty) = $event))
                }, [
                  _createElementVNode("option", _hoisted_16, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.all`)), 1),
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20
                ], 544), [
                  [_vModelSelect, filter.value.dificulty]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.categories`)), 1),
                _createVNode(_unref(Multiselect), {
                  modelValue: filter.value.categories,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filter.value.categories) = $event)),
                  options: _unref(categories).map(cat => ({ value: cat.id, label: cat.name })),
                  mode: "multiple",
                  "clear-on-select": false,
                  disabled: loading.value,
                  searchable: true,
                  label: "label",
                  "track-by": "value",
                  style: {"min-width":"200px"},
                  ref: "multiselect"
                }, null, 8, ["modelValue", "options", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("b", _hoisted_28, " - " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.challenge.progress_on_this_machine`)), 1)
                ]),
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (doSearch())),
                  class: "form-control",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filter.value.status) = $event))
                }, [
                  _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.all`)), 1),
                  _hoisted_30,
                  _hoisted_31,
                  _createElementVNode("option", _hoisted_32, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.user_progress.not_started_yet`)), 1)
                ], 544), [
                  [_vModelSelect, filter.value.status]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _withDirectives(_createElementVNode("select", {
                  onChange: _cache[6] || (_cache[6] = ($event: any) => (doSearch())),
                  class: "form-control",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filter.value.is_freemium) = $event))
                }, [
                  _createElementVNode("option", _hoisted_36, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.all`)), 1),
                  _hoisted_37,
                  _hoisted_38
                ], 544), [
                  [_vModelSelect, filter.value.is_freemium]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.challenge.search_by_tag`)), 1),
                _withDirectives(_createElementVNode("input", {
                  onKeyup: _cache[8] || (_cache[8] = ($event: any) => (doSearch())),
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filter.value.search) = $event)),
                  placeholder: "Challenge name, tag, etc..."
                }, null, 544), [
                  [_vModelText, filter.value.search]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("button", {
                  type: "button",
                  ref: "submitSearchButton",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (doSearch())),
                  id: "kt_search_in_submit",
                  class: "btn btn-lg btn-outline-info"
                }, [
                  (!loading.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.search`)), 1))
                    : _createCommentVNode("", true),
                  (loading.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.searching`)) + "... ", 1))
                    : _createCommentVNode("", true)
                ], 512)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            (_unref(challenges).length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("h4", _hoisted_51, [
                        _hoisted_52,
                        _hoisted_53,
                        _createElementVNode("a", _hoisted_54, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.challenge.no_machines_found`)), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _createElementVNode("a", _hoisted_55, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.challenge.try_change_filters_search_another_machine`)), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(challenges), (challenge) => {
              return (_openBlock(), _createElementBlock("div", {
                key: challenge.id,
                class: "col-md-6 col-xl-4"
              }, [
                _createElementVNode("a", {
                  href: '/training/challenges/' + challenge.id,
                  class: "card border-hover-primary",
                  style: {"cursor":"pointer","height":"400px"}
                }, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, [
                      (
                challenge?.percentage > 0 &&
                challenge?.percentage < 100
              )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.user_progress.in_progress`)), 1))
                        : _createCommentVNode("", true),
                      (challenge?.percentage == 100)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.user_progress.completed`)), 1))
                        : _createCommentVNode("", true),
                      (challenge?.percentage == 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.user_progress.not_started_yet`)), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, _toDisplayString(challenge?.name), 1),
                    _createElementVNode("div", _hoisted_64, [
                      (challenge?.dificulty == 'easy')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.easy`)), 1))
                        : _createCommentVNode("", true),
                      (challenge?.dificulty == 'medium')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.medium`)), 1))
                        : _createCommentVNode("", true),
                      (challenge?.dificulty == 'hard')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_67, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.hard`)), 1))
                        : _createCommentVNode("", true),
                      (challenge?.dificulty == 'insane')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.insane`)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_69,
                    _createElementVNode("div", _hoisted_70, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(challenge?.categories, (category) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: category.id,
                          class: "badge border border-gray-300 border-dashed rounded py-3 px-2 text-gray-800 justify-content-center"
                        }, _toDisplayString(category.name), 1))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, _toDisplayString(_unref(moment).utc(challenge?.release_at).format("DD MMMM, YYYY")), 1),
                        _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.release_date`)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, _toDisplayString(challenge.points), 1),
                        _createElementVNode("div", _hoisted_77, [
                          _createTextVNode("Total " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.of`)) + " XP ", 1),
                          _hoisted_78
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", {
                        class: "bg-primary rounded h-4px",
                        role: "progressbar",
                        style: _normalizeStyle('width: ' + challenge?.percentage + '%'),
                        "aria-valuenow": challenge?.percentage,
                        "aria-valuemin": "0",
                        "aria-valuemax": "100"
                      }, null, 12, _hoisted_80)
                    ]),
                    _createElementVNode("div", _hoisted_81, [
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("small", _hoisted_83, [
                          _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.creator`)) + " ", 1),
                          _hoisted_84
                        ]),
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("img", {
                              alt: "Pic",
                              src: challenge?.creator ? challenge?.creator?.profile_photo_path : '/media/avatars/blank.png',
                              title: challenge?.creator?.nick ? challenge?.creator?.nick : 'no nick'
                            }, null, 8, _hoisted_87)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_88, [
                        _hoisted_89,
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("div", _hoisted_91, [
                            _createElementVNode("img", {
                              alt: "Pic",
                              src: challenge?.first_blood?.avatar ? challenge?.first_blood?.avatar : '/media/avatars/blank.png'
                      ,
                              title: challenge?.first_blood?.nick ? challenge?.first_blood?.nick : 'no blood'
                            }, null, 8, _hoisted_92)
                          ])
                        ])
                      ])
                    ])
                  ])
                ], 8, _hoisted_56)
              ]))
            }), 128)),
            _createElementVNode("ul", _hoisted_93, [
              (_unref(currentMetadata)?.links)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(currentMetadata).links, (link) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: link.label
                    }, [
                      _createElementVNode("li", {
                        class: _normalizeClass('page-item m-1 cursor-pointer ' + (link.active ? 'active' : ''))
                      }, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => (goTo(link.url)),
                          class: "page-link"
                        }, [
                          _createElementVNode("span", {
                            innerHTML: link.label
                          }, null, 8, _hoisted_95)
                        ], 8, _hoisted_94)
                      ], 2)
                    ]))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("span", _hoisted_98, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.common.loading`)) + "...", 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})